import { Box, Card, CardContent, Typography } from "@mui/material";

import useResponsive from "@/hooks/useResponsive";

import Characteristics from "./Characteristics";
import { useState } from "react";
import { useSpring, animated } from "react-spring";
import { imageContainerStyles, industryCardStyles } from "./styles";

interface IProps {
  industryCard: IIndustryCard;
}

const IndustryCard: React.FC<IProps> = ({ industryCard }) => {
  const isDesktop = useResponsive("up", "md");
  const { title, subTitle, characteristics, imageUrl, thumbnail } =
    industryCard;

  const [imageLoaded, setImageLoaded] = useState(false); // Image loading state

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const fadeInProps = useSpring({
    opacity: imageLoaded ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  });

  const fadeInThumbProps = useSpring({
    opacity: imageLoaded ? 0 : 1, // Hide thumbnail when full image is loaded
    from: { opacity: 1 },
    config: { duration: 300 },
    filter: `blur(10px)`,
  });

  return (
    <Card variant="outlined" sx={industryCardStyles}>
      <CardContent sx={{ padding: "0 !important", mb: { xs: 3, md: 0 } }}>
        <Typography
          variant="h1"
          fontSize={{ xs: 32, md: 40 }}
          mb={{ xs: 2, md: 1 }}
        >
          {title}
        </Typography>
        <Typography variant="subtitle2" component="p" color="text.secondary">
          {subTitle}
        </Typography>

        {isDesktop && <Characteristics characteristics={characteristics} />}
      </CardContent>

      {/* Image */}
      <Box
        sx={{
          ...imageContainerStyles,
          position: "relative",
          img: { width: "100%", height: "100%", objectFit: "contain" },
        }}
      >
        <img
          src={imageLoaded ? imageUrl : thumbnail}
          alt={title + " preview"}
          style={{ opacity: 0, visibility: "hidden" }}
        />
        <animated.img
          src={thumbnail}
          alt={title + " preview"}
          style={{
            ...fadeInThumbProps,
            position: "absolute",
            zIndex: 1,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            transition: "opacity 0.3s ease",
          }}
        />
        <animated.img
          src={imageUrl}
          alt={title}
          style={{
            ...fadeInProps,
            position: "absolute",
            zIndex: 2,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            transition: "opacity 0.3s ease",
          }}
          onLoad={handleImageLoad}
        />
      </Box>

      {!isDesktop && <Characteristics characteristics={characteristics} />}
    </Card>
  );
};

export default IndustryCard;
